import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { inject, ref } from "vue";
import UserImageDoc from "@/projects/tenant/modules/users/components/UserImageDoc.vue";
import DocumentEmptyCard from "./DocumentEmptyCard.vue";
import {
  CurrentVerificationDocuments,
  userDocumentsInjectionKeys,
} from "./UserDocumentsInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationDocuments',
  setup(__props) {

const verificationDetails = inject(
  userDocumentsInjectionKeys.verificationDetails,
  ref<any>(null)
);
const verificationDocuments = inject(
  userDocumentsInjectionKeys.verificationDocuments,
  ref<CurrentVerificationDocuments>({
    idFront: null,
    idBack: null,
    address: null,
  })
);
const isShowUserInfos = inject(
  userDocumentsInjectionKeys.isShowUserInfos,
  ref(false)
);
const canVerifyDocument = inject(
  userDocumentsInjectionKeys.canVerifyDocument,
  ref(false)
);
const refreshData = inject(
  userDocumentsInjectionKeys.refreshData,
  async () => undefined
);

const handleDocumentApproved = (media: any) => {
  media.status = 2;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["justify-content-between", {
      'd-flex': !_unref(isShowUserInfos),
    }])
  }, [
    (_unref(verificationDocuments).idFront)
      ? (_openBlock(), _createBlock(UserImageDoc, {
          key: 0,
          class: "me-3",
          title: _unref(verificationDocuments).idFront.context || _ctx.$t('tip.idFront'),
          media: _unref(verificationDocuments).idFront,
          "verification-details": _unref(verificationDetails),
          "can-verify-document": _unref(canVerifyDocument),
          "refresh-on-approved": false,
          onDocumentApproved: handleDocumentApproved,
          onFileDeleted: _unref(refreshData)
        }, null, 8, ["title", "media", "verification-details", "can-verify-document", "onFileDeleted"]))
      : (_openBlock(), _createBlock(DocumentEmptyCard, {
          key: 1,
          class: "me-3",
          title: _ctx.$t('tip.idFront')
        }, null, 8, ["title"])),
    (_unref(verificationDocuments).idBack)
      ? (_openBlock(), _createBlock(UserImageDoc, {
          key: 2,
          class: "me-3",
          title: _unref(verificationDocuments).idBack.context || _ctx.$t('tip.idBack'),
          media: _unref(verificationDocuments).idBack,
          "verification-details": _unref(verificationDetails),
          "can-verify-document": _unref(canVerifyDocument),
          "refresh-on-approved": false,
          onDocumentApproved: handleDocumentApproved,
          onFileDeleted: _unref(refreshData)
        }, null, 8, ["title", "media", "verification-details", "can-verify-document", "onFileDeleted"]))
      : (_openBlock(), _createBlock(DocumentEmptyCard, {
          key: 3,
          class: "me-3",
          title: _ctx.$t('tip.idBack')
        }, null, 8, ["title"])),
    (_unref(verificationDocuments).address)
      ? (_openBlock(), _createBlock(UserImageDoc, {
          key: 4,
          class: "me-3",
          title: 
        _unref(verificationDocuments).address.context || _ctx.$t('tip.addressDocument')
      ,
          media: _unref(verificationDocuments).address,
          "verification-details": _unref(verificationDetails),
          "can-verify-document": _unref(canVerifyDocument),
          "refresh-on-approved": false,
          onDocumentApproved: handleDocumentApproved,
          onFileDeleted: _unref(refreshData)
        }, null, 8, ["title", "media", "verification-details", "can-verify-document", "onFileDeleted"]))
      : (_openBlock(), _createBlock(DocumentEmptyCard, {
          key: 5,
          class: "me-3",
          title: _ctx.$t('tip.addressDocument')
        }, null, 8, ["title"]))
  ], 2))
}
}

})